import Modal from './Modal'
import useModal from './hooks/useModal'
import modalReducer from './reducers/modalReducer'

export { useModal, modalReducer }

export default Modal
